/**
 * Alarm haptics. Watches the live safety-alarm state and buzzes once, firmly,
 * the moment a new alarm is RAISED (anchor dragging, grounding ahead, a close
 * AIS CPA, or a tide-height limit). It fires on the rising edge only, so a
 * standing alarm doesn't buzz on every render, just when it first goes off.
 *
 * MOB has its own distinct, stronger pattern fired at the point the crew triggers
 * it (voice or menu), not here, because MOB is an action the user takes rather
 * than an alarm the boat raises.
 */
import { useEffect, useRef } from 'react';
import { useAlarmsStore } from '@/store/alarms';
import { haptic } from '@/ui/haptics';

export function HapticsRunner() {
  const live = useAlarmsStore((s) => s.live);
  const masterMuted = useAlarmsStore((s) => s.masterMuted);
  const prev = useRef({ anchor: false, grounding: false, cpa: false, tideHeight: false, gnssJump: false, gnssLost: false, lowBattery: false });

  useEffect(() => {
    const now = {
      anchor: !!live.anchor,
      grounding: !!live.grounding,
      cpa: !!live.ais?.cpa,
      tideHeight: !!live.tideHeight,
      gnssJump: !!live.gnssJump,
      gnssLost: !!live.gnssLost,
      lowBattery: !!live.lowBattery,
    };
    const keys = Object.keys(now) as (keyof typeof now)[];
    const rising = keys.some((k) => now[k] && !prev.current[k]);
    // Master mute silences the buzz along with the siren. We still advance
    // prev.current so an alarm that rises while muted doesn't buzz the moment
    // mute is lifted; it only buzzes on a genuinely fresh rising edge.
    if (rising && !masterMuted) haptic('alarm');
    prev.current = now;
  }, [live, masterMuted]);

  return null;
}
